<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" href="#">WW</a>
    <ul class="navbar-nav mr-auto">
      <li title='Online Gallery'>
        <a class="nav-link active" [routerLink]="['/show55']">55th Show</a>
        <a class="nav-link active" [routerLink]="['/show54']">54th Show</a>
        <a class="nav-link active" [routerLink]="['/show53']">53rd Show</a>
        <a class="nav-link active" [routerLink]="['/show52']">52nd Show</a>
      </li>
    </ul>
</nav>

<div class="row">
    <div class="col">
      <app-nav-entries (gotoEntry)='onNavChanged($event)'></app-nav-entries>
    </div>
</div>
<div class="row outer">
    <div class="col">
        <app-gallery-show class="col" [showEntry]='entry'></app-gallery-show>
    </div>
</div>
